import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/views/Auth'
import Report from '@/views/Report'
import Reports from '@/views/Reports'
import Users from '@/views/Users'
import Project from '@/views/Project'
import Profile from '@/views/Profile'
import Privacy from '@/views/Privacy'
import About from '@/views/About'
import Monitor from '@/views/Monitor'
import NotFound from '@/views/404'
import store from '@/store'

Vue.use(Router)

let dataLayerEnrich = (e, p) => {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({ 'event': e, 'data': p })
}

const appRoutes = [
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: {
      requiresAuth: false, 
      title: 'Авторизация'
    }
  }, {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      requiresAuth: false, 
      title: 'Добро пожаловать'
    }
  }, {
    path: '/',
    name: 'reports',
    component: Reports,
    meta: {
      requiresAuth: true, 
      title: 'Отчеты'
    }
  }, {
    path: '/me',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true, 
      title: 'Профиль пользователя'
    }
  }, {
    path: '/r/:report_id',
    name: 'report',
    component: Report,
    meta: {
      requiresAuth: true, 
      title: 'Отчет'
    }
  }, {
    path: '/users',
    name: 'persons',
    component: Users,
    meta: {
      requiresAuth: true, 
      title: 'Пользователи'
    }
  }, {
    path: '/state',
    name: 'monitor',
    component: Monitor,
    meta: {
      requiresAuth: true, 
      title: 'Состояние'
    }
  }, {
    path: '/p/:project_id',
    name: 'project',
    component: Project,
    meta: {
      requiresAuth: true, 
      title: 'Проект'
    }
  }, {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      requiresAuth: false, 
      title: 'Политика конфиденциальности'
    }
  }, {
    path: '*',
    name: '404',
    component: NotFound,
    meta: {
      requiresAuth: false,
      title: 'Не смогли найти'
    }
  }
];

const router = new Router({
  routes: appRoutes,
  mode: 'history',
  base: process.env.BASE_URL
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  store.commit('clearHeaders');
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({ path: '/auth', query: { redirect: to.fullPath }});
  } else {
    if (to.name === "auth" && to.hash.includes("access_token")) {
      next({path: to.fullPath.replace('#', '?')})
    } else if (to.hash.length && to.name !== "auth") {
      let modifiedPath = to.hash.replace('#', '')
      if (to.hash.includes('/reports/')) {
        modifiedPath = modifiedPath.replace('/reports/', '/r/')
      }
      if (to.hash.includes('/projects/')) {
        modifiedPath = modifiedPath.replace('/projects/', '/p/')
      }
      next({path: modifiedPath})
    } else {
      if (to.matched.some(record => !record.meta.requiresAuth && record.name != '404' && record.name != 'privacy' && record.name != 'about') && store.state.isLoggedIn) {
        next({ path: '/'})
      } else {
        next()
      }
    }
  }
});

router.afterEach( (to, from) => {
  document.title = store.getters.pageTitle + ' | ' + to.meta.title;
  if (to.name != 'report' && to.name != 'project' && to.name != 'auth') {
    dataLayerEnrich('navigation', {
      path: to.fullPath,
      title: document.title
    })
  }
});

export default router;
